/**
 * @description client action
 */

import {types} from '../constants/types'
import {isObject} from '../../utils/index'
import config from '../../config/'

const {UPDATE_CLIENT_INFO, UPDATE_USER_INFO, UPDATE_ENV} = types

export default {
  appInfoInitialize({commit, state}) {
    return new Promise((resolve) => {
      if (state.client.env === 'app') { // 如果是APP动态引入客户端服务模块
        import('../../services/clientService').then(res => {
          const {clientService} = res
          let task = []
          // 更新客户端数据
          clientService.getClientInfo({}, data => {
            if (isObject(data)) {
              config.versionName = data.versionName
              commit(UPDATE_CLIENT_INFO, {data})
              if (config.fixationVersionId === 'true') {
                commit(UPDATE_CLIENT_INFO, {
                  data: {
                    clientVersionId: config.clientVersionId
                    , channelId: config.channelId
                  }
                })
              }
            }
            task.push(Promise.resolve(data))
          })
          clientService.getUserInfo({}, data => {
            if (isObject(data)) {
              // 是否登录失效
              data.overdue = !data.userID
              commit(UPDATE_USER_INFO, {data})
            }
            task.push(Promise.resolve(data))
          })
          // 所有数据更新后再做任务
          Promise.all(task).then(resolve)
        })
      } else if (state.client.env === 'wxMini') {
        commit(UPDATE_CLIENT_INFO, {
          data: {
            clientVersionId: config.fixationVersionId === 'true' ? config.clientVersionId : (config.wxMiniClientVersionId || config.clientVersionId)
            , channelId: config.fixationVersionId === 'true' ? config.channelId : (config.wxMiniChannelId || config.channelId)
          }
        })
        resolve()
      } else if (state.client.env === 'wx') {
        commit(UPDATE_CLIENT_INFO, {
          data: {
            clientVersionId: config.fixationVersionId === 'true' ? config.clientVersionId : (config.wxClientVersionId || config.clientVersionId)
            , channelId: config.fixationVersionId === 'true' ? config.channelId : (config.wxChannelId || config.channelId)
          }
        })
        resolve()
      } else {
        resolve()
      }
    })
  },
  updateUserInfo({commit}, {data}) {
    commit(UPDATE_USER_INFO, {data})
  },
  // 获取当前环境
  getEnv({commit}) {
    return new Promise((resolve) => {
      if (config.env === 'wx') {
        /* eslint-disable */
        // 非同步接口需要再行判断一次
        try {
          wx.miniProgram.getEnv((res) => {
            commit(UPDATE_ENV, {
              data: {
                env: res.miniprogram ? 'wxMini' : 'wx'
              }
            })
            resolve()
          })
        } catch (e) {
          commit(UPDATE_ENV, {
            data: {
              env: 'wx'
            }
          })
          resolve()
        }
      } else {
        commit(UPDATE_ENV, {
          data: {
            env: config.env
          }
        })
        resolve()
      }
    })
  }
}
